<app-loader *ngIf="isDisabled"></app-loader>
<form name="PerquisiteForm" (ngSubmit)="Save(PerquisiteForm)" #PerquisiteForm="ngForm">
<div class="card">
    <div class="card-header">
        Perquisite Form
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-4">
                <label>Emp Code</label>
                <input name="empcode" class="form-control" placeholder="" [disabled]="true" [(ngModel)]="Data.empCode">
            </div>
            <div class="col-md-4">
                <label>Emp Type</label>
                <input name="emptype" class="form-control" placeholder="" [disabled]="true" [(ngModel)]="Data.empType">
            </div>
            <div class="col-md-4">
                <label>Month Year<span class="text-danger">*</span></label>
                <ngb-datepicker [startDate]="startDate"  [(ngModel)]="Data.monthYear" class="month-year" (navigate)="onNavigate($event)" name="dateselect5" style="width: 100%;"></ngb-datepicker>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <label>Perquisite Name<span class="text-danger">*</span></label>
                <ng-select name="perquisitename" placeholder="Select Perquisite" [items]="PerquisiteLoad"
                    bindLabel="Perquisite_Name" bindValue="ESS_PerquisiteMasterID" [(ngModel)]="Data.perquisite" (change)="onPerquisiteChange(Data.perquisite)" required>
                </ng-select>
            </div>
            <div class="col-md-4">
                <label>Sub Payhead Name<span class="text-danger">*</span></label>
                <input name="payheadname" class="form-control" placeholder="" [(ngModel)]="Data.subHeadName"
                    #payheadname="ngModel" required>
            </div>
            <div class="col-md-4">
                <label>Gross Value<span class="text-danger">*</span></label>
                <input name="grossvalue" class="form-control" placeholder="" [(ngModel)]="Data.grossValue"
                    #grossvalue="ngModel" required>  
            </div>
            <div class="col-md-4">
                <label>Employee Recovery<span class="text-danger">*</span></label>
                <input name="employeerecovery" class="form-control" placeholder="" [(ngModel)]="Data.employeeRecovery" #employeerecovery="ngModel" required>  
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button  (click)="close()" type="button" class="btn btn-outline-primary btn-sm" [disabled]="isDisabled">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'X Cancel':'Loading...'}}
                </button>
            </div>
            <div class="col-auto">
                <button type="submit" class="btn btn-primary btn-sm" [disabled]="isDisabled">
                    <i class="bi bi-download me-1" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>
</form>